import React from 'react';

import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { ThemeProvider } from '@material-ui/styles';

import Theme from './components/theme';
import Hero from './components/Hero';
import MapStat1 from './components/MapStat1';
import Trailer from './components/Trailer';
import EpisodesMain from './components/EpisodesMain';
import QuoteBlock from './components/episode1/QuoteBlock';
import Navbar from './components/navbars/Navbar';
import NavbarTab from './components/navbars/NavbarTab';
import NavbarMob from './components/navbars/NavbarMob';
import Footer from './components/common-footer/Footer';
import MapStat2 from './components/MapStat2';

function App() {
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesMD = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <ThemeProvider theme={Theme}>
      {matchesSM ? <NavbarMob /> : matchesMD ? <NavbarTab /> : <Navbar />}
      <Hero />
      {/* <Gradient /> */}
      <Trailer />
      <MapStat2 />
      <MapStat1 />
      <EpisodesMain />
      <QuoteBlock />
      <Footer />
    </ThemeProvider>
  );
}

export default App;
